function Referenzen() {
  return <div className="main-wrapper">
    
    

    <h2>Referenzen</h2>

    <p>
      Hier finden Sie bald Kundenmeinungen...
    </p>

    

  </div>;
}
export default Referenzen;